import React, { FunctionComponent, useEffect, useState } from 'react';

interface Props extends React.HTMLAttributes<SVGSVGElement> {
  icon: any;
  color?: string;
  size?: number;
  style?: React.CSSProperties;
  className?: string;
  testID?: string;
}

const FontAwesomeIcon: FunctionComponent<Props> = ({
  className,
  icon,
  size,
  style,
  color,
  testID,
  title,
  ...props
}) => {
  const [path, setPath] = useState('');

  useEffect(() => {
    setPath(icon.icon[4]);
  }, [icon]);

  return (
    <svg
      className={className}
      aria-hidden="true"
      focusable="false"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${icon.icon[0]} ${icon.icon[1]}`}
      style={{
        display: 'inline-block',
        overflow: 'visible',
        fontSize: size,
        ...style,
        height: '1em',
      }}
      color={color}
      data-testid={testID}
      {...props}
    >
      {title && <title>{title}</title>}
      {path && <path fill="currentColor" d={path} />}
    </svg>
  );
};

export default FontAwesomeIcon;
